export class DashboardLineColors {

    protected colors: Object = {};

    constructor() {
        this.colors['OK - DOI_LINE_EXISTS'] = {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(23, 234, 238, 0.92)',
            pointBackgroundColor: 'rgba(9, 30, 78, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            //pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        };

        this.colors['OK - DOI_RIGHT_PERSON'] = {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(32, 178, 16, 1)',
            pointBackgroundColor: 'rgba(1, 34, 5, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            //pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        };

        this.colors['ABSENT_SUBSCRIBER'] = {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(231, 102, 4, 1)',
            pointBackgroundColor: 'rgba(100, 44, 2, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
        };

        this.colors['KO'] = {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(225, 16, 5, 1)',
            pointBackgroundColor: 'rgba(100, 44, 2, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
        };

        this.colors['UNKNOWN'] = {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderColor: 'rgba(99, 100, 121, 0.85)',
            pointBackgroundColor: 'rgba(100, 44, 2, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
        };

        this.colors['ERROR'] = {
            backgroundColor: 'rgba(38, 19, 23, 0.85)',
            borderColor: 'rgba(99, 100, 121, 0.85)',
            pointBackgroundColor: 'rgba(100, 44, 2, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
        }
    }

    getColorData(status: string): any {
        return (this.colors.hasOwnProperty(status)) ? this.colors[status] : false;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/model/DashboardLineColors.ts